import { useQuery } from 'react-apollo';
import { differenceInDays } from 'date-fns';

import { useSessionData, AccessStatus } from '@confluence/session-data';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition';

import { TrialDetailsQuery } from '../TrialDetailsQuery.graphql';
import type { TrialDetailsQuery as TrialDetailsQueryType } from '../__types__/TrialDetailsQuery';

const getTrialDaysLeft = (trialEndDate: string | null | undefined) => {
	if (!trialEndDate) {
		return null;
	}

	// +1 day to round up for fractional days
	return differenceInDays(new Date(trialEndDate), new Date()) + 1;
};

export const useIsEligibleForExplorePremiumCard = () => {
	const { accessStatus, isLoggedIn, edition } = useSessionData();
	const isLicensed = accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS;

	const skipTrialDetailsQuery = Boolean(
		!isLoggedIn || !isLicensed || edition !== ConfluenceEdition.PREMIUM,
	);

	const { data, loading, error } = useQuery<TrialDetailsQueryType>(TrialDetailsQuery, {
		skip: skipTrialDetailsQuery,
	});

	const formattedTrialDaysLeft = getTrialDaysLeft(data?.license?.trialEndDate) ?? 0;

	return {
		isEligible: formattedTrialDaysLeft > 0,
		formattedTrialDaysLeft,
		loading,
		error,
	};
};
